import { useForm } from 'react-hook-form';
import { shippingSelfQuery } from '../../../services/react-query/optionMasterQuery';
import { useGetInfoClaimData } from './useGetInfoClaimData';
import { useCallback, useState } from 'preact/hooks';
import { openAlert } from '../../../components/alert/hooks';
import { useModal } from '../../../components/modal/hooks/useModal';
import { onUploadFile } from './onUploadFile';

export const useGetScanDeliveryList = () => {
  const { control, getValues, setValue, setFocus, reset, handleSubmit } = useForm();
  const [selectedRow, setSelectedRow] = useState();
  const [tableData, setTableData] = useState([]);
  const { data: shippingSelfOptions } = shippingSelfQuery();
  const { open: openTracking, onToggle: onToggleTracking } = useModal();
  const { open: openUploadExcel, onToggle: onToggleUploadExcel } = useModal();
  const { mutate: onEnterClaimcode, loading: isLoadingClaimcode } = useGetInfoClaimData({
    setValue,
  });

  const { mutate: onSubmitTracking, loading: isLoadingOnsubmitTracking } = onUploadFile({
    reset,
    setTableData,
  });

  const handleOnEnter = useCallback(
    async (event, fieldName) => {
      if (event.key === 'Enter') {
        event.preventDefault();
        const value = getValues(fieldName);

        switch (fieldName) {
          case 'claimCode':
            if (value) {
              const existingClaim = tableData.find((item) => item.claimCode === value);

              if (existingClaim) {
                openAlert({
                  type: 'warning',
                  model: 'message',
                  message: 'เลขที่เคลมซ้ำ ไม่สามารถเพิ่มข้อมูลได้',
                });
                reset({ claimCode: '' });
                setFocus('claimCode');
                return;
              }

              onEnterClaimcode(value, {
                onSuccess: () => {
                  setFocus('trackingNumber');
                },
              });
            }
            break;

          case 'trackingNumber':
            if (value) {
              const existingTracking = tableData.find((item) => item.trackingNumber === value);

              if (existingTracking) {
                openAlert({
                  type: 'warning',
                  model: 'message',
                  message: 'เลขพัสดุซ้ำ ไม่สามารถเพิ่มข้อมูลได้',
                });
                setValue('trackingNumber', '');
                setFocus('trackingNumber');
                return;
              }

              setTableData((prevData) => [...prevData, getValues()]);
              reset({ trackingNumber: '' });
              setFocus('claimCode');
            }
            break;
        }
      }
    },
    [getValues, tableData, reset, setValue],
  );
  const handleDeleteRecord = (record) => {
    setTableData((prevData) => prevData.filter((item) => item.claimId !== record.claimId));
  };

  const onOpenTracking = (record) => {
    setSelectedRow(record);
    onToggleTracking({ defaultValues: record });
  };

  const onSubmit = (values) => {
    const shippingId = values.shippingId;
    const updatedTableData = tableData.map((item) => ({
      ...item,
      shippingId,
    }));

    onSubmitTracking(updatedTableData);
  };
  return {
    control,
    getValues,
    setValue,
    shippingSelfOptions,
    handleOnEnter,
    isLoadingClaimcode,
    setFocus,
    tableData,
    handleDeleteRecord,
    openTracking,
    onToggleTracking,
    setTableData,
    onOpenTracking,
    isLoadingOnsubmitTracking,
    onSubmit,
    handleSubmit,
    openUploadExcel,
    onToggleUploadExcel,
    selectedRow,
  };
};
